/* WOLF BROS: add to cart = small toast + fly to cart icon (no big cart popup) */
(function () {
  if (window.wbCartAdded) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var css =
    '.wb-fly{position:fixed;z-index:2147483000;object-fit:cover;pointer-events:none;border-radius:12px;box-shadow:0 10px 30px rgba(0,0,0,.35)}' +
    '.wb-toast{position:fixed;z-index:2147482000;left:24px;bottom:24px;width:min(380px,calc(100vw - 24px));box-sizing:border-box;display:grid;grid-template-columns:56px 1fr auto;gap:12px;align-items:center;padding:14px 14px 16px;border-radius:16px;background:rgb(var(--color-background,18,18,18));color:rgb(var(--color-foreground,255,255,255));border:1px solid rgba(var(--color-foreground,255,255,255),.12);box-shadow:0 18px 50px rgba(0,0,0,.45);overflow:hidden;opacity:0;transform:translateY(24px) scale(.98);transition:transform .35s cubic-bezier(.2,.8,.2,1),opacity .3s ease;font-family:var(--font-body-family)}' +
    '.wb-toast.is-in{opacity:1;transform:none}' +
    '@media (max-width:749px){.wb-toast{left:12px;right:84px;width:auto;bottom:16px}}' +
    '.wb-toast__img{position:relative;width:56px;height:56px}' +
    '.wb-toast__img img{width:56px;height:56px;object-fit:cover;border-radius:10px;display:block}' +
    '.wb-toast__tick{position:absolute;right:-6px;bottom:-6px;width:22px;height:22px;border-radius:50%;display:grid;place-items:center;font-size:12px;font-weight:800;background:rgb(var(--color-button,228,252,2));color:rgb(var(--color-button-text,0,0,0));border:2px solid rgb(var(--color-background,18,18,18))}' +
    '.wb-toast__body{min-width:0}' +
    '.wb-toast__title{margin:0;font-size:11px;font-weight:800;letter-spacing:.14em;text-transform:uppercase;color:rgb(var(--color-button,228,252,2))}' +
    '.wb-toast__name{margin:3px 0 0;font-size:14px;font-weight:600;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.wb-toast__variant{margin:2px 0 0;font-size:12px;opacity:.65}' +
    '.wb-toast__close{align-self:start;background:none;border:0;padding:0 2px;color:inherit;font-size:22px;line-height:1;cursor:pointer;opacity:.6}' +
    '.wb-toast__actions{grid-column:1/-1;display:flex;gap:8px}' +
    '.wb-toast__view,.wb-toast__checkout{flex:1;height:40px;border-radius:10px;font:inherit;font-size:12px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;text-decoration:none}' +
    '.wb-toast__view{background:transparent;color:inherit;border:1px solid rgba(var(--color-foreground,255,255,255),.25)}' +
    '.wb-toast__checkout{border:0;background:rgb(var(--color-button,228,252,2));color:rgb(var(--color-button-text,0,0,0))}' +
    '.wb-toast__bar{position:absolute;left:0;bottom:0;width:100%;height:3px;background:rgb(var(--color-button,228,252,2));transform-origin:left;animation:wbToastBar 4.5s linear forwards}' +
    '.wb-toast:hover .wb-toast__bar{animation-play-state:paused}' +
    '@keyframes wbToastBar{from{transform:scaleX(1)}to{transform:scaleX(0)}}';
  function injectCss() {
    if (document.getElementById('wb-cart-toast-css')) return;
    var s = document.createElement('style');
    s.id = 'wb-cart-toast-css';
    s.textContent = css;
    document.head.appendChild(s);
  }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Update the cart (bubble + popup/drawer contents) without opening it
  function renderQuiet(cart, response) {
    var drawer = cart.tagName === 'CART-DRAWER';
    if (drawer) {
      cart.productId = response.id;
      var inner = cart.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      cart.classList.remove('is-empty');
    } else {
      cart.cartItemKey = response.key;
    }
    cart.getSectionsToRender().forEach(function (s) {
      var el = drawer && s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (!el || !response.sections[s.id]) return;
      el.innerHTML = cart.getSectionInnerHTML(response.sections[s.id], s.selector);
    });
    if (drawer) {
      setTimeout(function () {
        var ov = cart.querySelector('#CartDrawer-Overlay');
        if (ov) ov.addEventListener('click', cart.close.bind(cart));
      });
    } else if (cart.header && cart.header.reveal) {
      cart.header.reveal();
    }
  }
  function findImage(form) {
    var root = form.closest('quick-add-modal') || form.closest('.product') || form.closest('.shopify-section') || document;
    var list = root.querySelectorAll('.product__media-item.is-active img, .product__media img, .card__media img, img');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 40 && r.height > 40 && r.bottom > 0 && r.top < window.innerHeight) return list[i];
    }
    return null;
  }
  function bump(t) {
    if (!t || reduced || !t.animate) return;
    t.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(.9)' }, { transform: 'scale(1)' }], { duration: 450, easing: 'ease-out' });
  }
  function fly(img) {
    var target = document.getElementById('cart-icon-bubble');
    if (!target) return;
    if (!img || reduced || !document.body.animate) return bump(target);
    var r = img.getBoundingClientRect(), t = target.getBoundingClientRect();
    var size = Math.min(r.width, r.height, 220);
    var x = r.left + r.width / 2 - size / 2, y = r.top + r.height / 2 - size / 2;
    var el = document.createElement('img');
    el.src = img.currentSrc || img.src;
    el.alt = '';
    el.className = 'wb-fly';
    el.style.cssText = 'left:' + x + 'px;top:' + y + 'px;width:' + size + 'px;height:' + size + 'px';
    document.body.appendChild(el);
    var dx = t.left + t.width / 2 - (x + size / 2), dy = t.top + t.height / 2 - (y + size / 2);
    var a = el.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + dx * 0.4 + 'px,' + (dy * 0.4 - 90) + 'px) scale(.55)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08)', opacity: 0.5, borderRadius: '50%' },
      ],
      { duration: 750, easing: 'cubic-bezier(.5,0,.3,1)' }
    );
    a.onfinish = function () { el.remove(); bump(target); };
  }
  function hideToast(el) {
    if (!el || !el.parentNode) return;
    el.classList.remove('is-in');
    setTimeout(function () { el.remove(); }, 350);
  }
  function toast(cart, response) {
    injectCss();
    var old = document.querySelector('.wb-toast');
    if (old) old.remove();
    var item = response.items && response.items.length ? response.items[0] : response;
    var src = item.image || (item.featured_image && item.featured_image.url) || '';
    if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var el = document.createElement('div');
    el.className = 'wb-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="wb-toast__img">' + (src ? '<img alt="" src="' + esc(src) + '">' : '') + '<span class="wb-toast__tick" aria-hidden="true">&#10003;</span></div>' +
      '<div class="wb-toast__body"><p class="wb-toast__title">Added to cart</p><p class="wb-toast__name">' + esc(item.product_title) + '</p>' +
      (variant ? '<p class="wb-toast__variant">' + esc(variant) + '</p>' : '') + '</div>' +
      '<button type="button" class="wb-toast__close" aria-label="Close">&times;</button>' +
      '<div class="wb-toast__actions"><button type="button" class="wb-toast__view">View cart</button><a class="wb-toast__checkout" href="/checkout">Checkout</a></div>' +
      '<span class="wb-toast__bar"></span>';
    document.body.appendChild(el);
    el.querySelector('.wb-toast__close').addEventListener('click', function () { hideToast(el); });
    el.querySelector('.wb-toast__view').addEventListener('click', function () {
      hideToast(el);
      setTimeout(function () { cart.open(document.getElementById('cart-icon-bubble')); }, 30);
    });
    el.querySelector('.wb-toast__bar').addEventListener('animationend', function () { hideToast(el); });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-in'); });
    });
  }
  window.wbCartAdded = function (cart, response, form) {
    if (!cart || !response.sections || typeof cart.getSectionsToRender !== 'function') return cart.renderContents(response);
    try {
      renderQuiet(cart, response);
    } catch (e) {
      return cart.renderContents(response);
    }
    fly(findImage(form));
    setTimeout(function () { toast(cart, response); }, reduced ? 0 : 300);
  };
})();

class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.variantIdInput.disabled = false;
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    this.submitButton = this.querySelector('[type="submit"]');
    this.submitButtonText = this.submitButton.querySelector('span');
    if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    this.hideErrors = this.dataset.hideErrors === 'true';
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
    this.handleErrorMessage();
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    const variantId = formData.get('id');
    const quantity = parseInt(formData.get('quantity')) || 1;
    const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);
          this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
          linesUpdateDeferred?.reject(new Error(response.description || response.message));
          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          this.resolveCartLinesUpdate(linesUpdateDeferred);
          window.location = window.routes.cart_url;
          return;
        }

        this.resolveCartLinesUpdate(linesUpdateDeferred);

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: variantId,
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  window.wbCartAdded(this.cart, response, this);
                });
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          CartPerformance.measure('add:paint-updated-sections', () => {
            window.wbCartAdded(this.cart, response, this);
          });
        }
      })
      .catch((e) => {
        console.error(e);
        this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
        linesUpdateDeferred?.reject(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');
        CartPerformance.measureFromEvent('add:user-action', evt);
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) return;
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
    if (errorMessage) this.errorMessage.textContent = errorMessage;
  }

  toggleSubmitButton(disable = true, text) {
    if (disable) {
      this.submitButton.setAttribute('disabled', 'disabled');
      if (text) this.submitButtonText.textContent = text;
    } else {
      this.submitButton.removeAttribute('disabled');
      this.submitButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  createCartLinesUpdateEvent(variantId, quantity) {
    const { CartLinesUpdateEvent } = window.StandardEvents || {};
    if (!CartLinesUpdateEvent) return null;
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity }],
        promise: deferred.promise,
      })
    );
    return deferred;
  }

  resolveCartLinesUpdate(deferred) {
    if (!deferred) return;
    const { CartLinesUpdateEvent } = window.StandardEvents || {};
    if (!CartLinesUpdateEvent) return;
    const pendingCartDataPromise = typeof CartItems !== 'undefined'
      ? CartItems.fetchCartData()
      : fetch(`${routes.cart_url}.json`).then((response) => response.json());
    pendingCartDataPromise
      .then((cart) => {
        if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
      })
      .catch((e) => deferred.reject(e));
  }

  dispatchCartErrorEvent(message, code) {
    const { CartErrorEvent } = window.StandardEvents || {};
    if (!CartErrorEvent) return;
    this.dispatchEvent(new CartErrorEvent({ error: message, code }));
  }

  get variantIdInput() {
    return this.form.querySelector('[name=id]');
  }
}

if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);